(function () {
  var config = window.SiteAudioConfig;
  if (!config || !config.url) return;

  var btn = document.querySelector('.site-audio-btn');
  if (!btn) return;

  var audio = new Audio(config.url);
  audio.loop = config.loop !== false;
  audio.volume = typeof config.volume === 'number' ? config.volume : 0.8;

  function sync() {
    var playing = !audio.paused;
    btn.classList.toggle('is-muted', !playing);
    btn.setAttribute('aria-pressed', String(playing));
  }

  audio.addEventListener('play', sync);
  audio.addEventListener('pause', sync);

  btn.addEventListener('click', function () {
    if (audio.paused) {
      audio.play().catch(function () {});
    } else {
      audio.pause();
    }
  });
})();
